import { Navigate, Outlet } from "react-router-dom";
import { getItem } from "../services/localStorage.service";

const RoleAccess = ({ roles = [] }: any) => {
  const accountProfile = getItem("account_profile");
  const userRoleId = accountProfile.role_id;

  return roles.length && roles.includes(userRoleId) ? (
    <Outlet />
  ) : (
    <Navigate to="/" replace />
  );
};

export default RoleAccess;
